import React, { FunctionComponent, useEffect, useState } from 'react';
import { chooseRandomElements } from '../../utils/utils';
import { InternalLink } from '../internal-link/internal-link';
import styles from './our-team-photos-link.module.scss';

export interface IOurTeamPhotosLinkProps {
  internalLinktoSection: string;
  ctaText: string;
  allEmployeePhotos: string[];
}

export const OurTeamPhotosLink: FunctionComponent<IOurTeamPhotosLinkProps> = props => {
  const { internalLinktoSection, allEmployeePhotos, ctaText } = props;

  const numberOfChosenObjects = 8;
  const [arrayOfPersons, setArrayOfPersons] = useState<string[]>([]);
  useEffect(() => {
    setArrayOfPersons(
      chooseRandomElements(allEmployeePhotos, numberOfChosenObjects)
    );
  }, [allEmployeePhotos]);

  return (
    <div className={styles.wrapper}>
      <InternalLink
        url={internalLinktoSection}
        className={styles.animationContainer}
      >
        {arrayOfPersons.map((personPhoto, n) => (
          <div
            key={n}
            style={{
              backgroundImage: `url(${personPhoto})`
            }}
            className={styles.smallPersonImage}
          />
        ))}
        <div className={styles.ctaContent}>
          <div className={styles.roundButton} data-type="roundButton">
            <i className={`material-icons md-36 ${styles.arrowIcon}`}>
              chevron_right
            </i>
          </div>
          <p className={styles.ctaTextStyle}>{ctaText}</p>
        </div>
      </InternalLink>
    </div>
  );
};
